import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DiaryNoteDetailsComponent } from '../details/diary-note-details.component';
import { DiaryNoteService } from '@features/diary-notes/services/diary-note.service';
import { DiaryNote } from '@features/diary-notes/model/diary-note';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-diary-note-edit',
  templateUrl: '../details/diary-note-details.component.html',
  styleUrls: ['../details/diary-note-details.component.scss']
})
export class DiaryNoteEditComponent
  extends DiaryNoteDetailsComponent
  implements OnInit
{
  constructor(diaryNoteService: DiaryNoteService, protected fb: FormBuilder) {
    super(diaryNoteService, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  get saveLabel(): string {
    return 'Save';
  }

  get title(): string {
    return 'Edit Diary Note';
  }

  get isNewDiaryNote(): boolean {
    return false;
  }

  content(): Observable<DiaryNote.Model> {
    return this.diaryNoteService.getDiaryNoteForEdit(
      this.entityId,
      this.diaryNoteId
    );
  }
}
